import classNames from 'classnames';
import React from 'react'
import { ITab } from 'redux/app/vessel/onboard/types';

type OwnProps = {
	tabs: ITab[];
	activeTab?: string;
	onTabChange?: (tabId: string) => void;
	onClickHandler?: (tab?: ITab) => void;
	setActiveTab: (tabId: string) => void;
	vesselId?: string;
	isUserThirdParty?: boolean;
	allowedModulesForThirdParty?: string[];
	className?: string;
};
function TabNavigation(props: OwnProps) {
	const {
		tabs,
		activeTab,
		setActiveTab,
		onTabChange,
		onClickHandler,
		vesselId,
		isUserThirdParty,
		allowedModulesForThirdParty,
		className
	} = props;
	return (
		<div className={`w-full overflow-x-auto ${className}`}>
			<nav className="flex">
				{/* // if user is third party, then only show the allowed modules */}
				{tabs.map((tab) => {
					if (
						isUserThirdParty &&
						!allowedModulesForThirdParty?.includes(tab.id)
					) {
						return null;
					}
					return (
						// if user is third party, then only show the allowed modules

						<div
							className={classNames(
								"flex cursor-pointer  justify-center items-center gap-0 px-2 hover:rounded hover:bg-lightBlue hover:text-blue-500", {
								"border-b-2 border-blue-500": activeTab === tab.id,
								"border-transparent":
									activeTab !== tab.id,
							}
							)}
							onClick={() => {
								setActiveTab(tab.id);
								if(onTabChange && tab?.url && vesselId) {
									return onTabChange(
										// route to the tab path
										tab.url(vesselId)
									);
								} else if(onClickHandler) {
									onClickHandler(tab);
								}
							}}
							key={tab.id}
						>
							{tab?.icon ?
								<span
									className={classNames(
										`h-4 w-4 bp3-icon bp3-icon-${tab.icon.toLowerCase()}`,
										{
											"border-blue-500 text-blue-600":
												activeTab === tab.id,
											"border-transparent text-gray-700 hover:text-gray-900 hover:border-gray-300":
												activeTab !== tab.id,
										}
									)}
								/>
								: null
							}

							<button
								key={tab.id}
								className={classNames(
									"py-3 mx-2 font-medium text-sm whitespace-nowrap inline-flex items-center",
									{
										"border-blue-500 text-blue-600":
											activeTab === tab.id,
										"border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300":
											activeTab !== tab.id,
									}
								)}
							>
								{tab.label}
							</button>
						</div>
					);
				})}
			</nav>
		</div>
	);
};

export default TabNavigation;